<template>
  <div class="plate">
    <div class="parking">
      <img src="@/assets/parking.png" alt="" srcset="">
    </div>
    <!-- <div class="forms">
      <input type="text" v-model="plate" placeholder="请输入车牌号，例如：陕F12345">
      <van-cell is-link title="车牌颜色" :value="actionsValue" @click="show = true" />
    </div> -->
    <div class="search-title">
      <div>
        <span>请输入车牌号</span>
      </div>

      <div style="display: flex;align-items:center">
        <div class="change-key-broad" @click="toggleKeyboardMode">
          <span style="font-size: 16px;">{{ useSystemKeyboard ? '系统键盘' : '车牌键盘' }}</span>
        </div>
        <img style="width: 20px; height:20px" src="@/assets/change.png" alt="" srcset="" />
      </div>
    </div>

    <div class="lisence_box" @click="handlePlateClick" @longpress="toggleKeyboardMode">
      <!-- 使用 textarea 替代 input 隐藏光标 -->
      <textarea v-if="useSystemKeyboard" class="system-input-cover" :value="plate" @input="onSystemInput"
        :maxlength="isNewEnergy" :show-confirm-bar="false" :focus="useSystemKeyboard" :adjust-position="false"
        :cursor-spacing="0" :selection-start="0" :selection-end="0" @blur="onTextareaBlur" @focus="onTextareaFocus"
        @compositionstart="isComposing = true" @compositionend="handleCompositionEnd"></textarea>

      <div v-for="(it, key) in boxs" :key="key">{{ it || '' }}</div>
    </div>

    <div style="text-align:center">
      <van-radio-group v-model="plateColor" direction="horizontal" style="display: inline-block;" @change="radioChange"
        class="lisence_check">
        <van-radio name="1" shape="dot" icon-size="16px" checked-color="#1CA6FF">蓝牌</van-radio>
        <van-radio name="5" shape="dot" icon-size="16px" checked-color="#1CA6FF">绿牌</van-radio>
        <van-radio name="2" shape="dot" icon-size="16px" checked-color="#1CA6FF">黄牌</van-radio>
        <van-radio name="3" shape="dot" icon-size="16px" checked-color="#1CA6FF">白牌</van-radio>
        <van-radio name="4" shape="dot" icon-size="16px" checked-color="#1CA6FF">黑牌</van-radio>
      </van-radio-group>
    </div>

    <div class="history-view">
      <span class="history-plate-title">历史查询车牌</span>
      <img @click="clearHistoryBtn" src="@/assets/delete.png" />
    </div>

    <div class="history-plate">
      <span class="plate" v-for="item in historyPlate" @click="clickHistoryPlate(item)">
        {{ item.plate }}
      </span>
    </div>


    <cui-plate v-model="plate" :limit="isNewEnergy" ref="plate"></cui-plate>
    <button type="submit" class="search" @click="search">查询</button>
    <van-action-sheet v-model="show" :actions="actions" close-on-click-action @select="onSelect" />
  </div>
</template>

<script>
export default {
  name: "searchPlate",
  title: "车牌号查询",
  data() {
    return {
      plate: "",
      plateColor: "1",
      show: false,
      actions: [
        { name: "蓝牌", value: "1" },
        { name: "绿牌", value: "5" },
        { name: "黄牌", value: "2" },
        { name: "白牌", value: "3" },
        { name: "黑牌", value: "4" },
      ],
      actionsValue: "蓝牌",
      isNewEnergy: 7,
      useSystemKeyboard: false,
      historyPlate: [],
    };
  },
  watch: {
    plate: function (value) {
      this.plate = value.toUpperCase();
    },
  },
  created() {
    this.$parent.hiddenBack();
    this.getHistoryPlate()
  },
  computed: {
    boxs() {
      let arr = this.plate.split('').map(char => char.toUpperCase());
      // 补全到指定长度（用于显示空格）
      while (arr.length < this.isNewEnergy) {
        arr.push('')
      }
      return arr.slice(0, this.isNewEnergy)
    }
  },
  methods: {
    handlePlateClick() {
      if (this.useSystemKeyboard) {
        // 点击时 textarea 会自动聚焦并弹出键盘
        return
      } else {
        this.$refs.plate.openKeyboard()
      }
    },
    radioChange(value) {
      console.log('选中的车牌颜色值:', value)
      // 你可以在这里做其他逻辑，比如更新 actionsValue 等
      const val = value
      this.plateColor = val
      this.isNewEnergy = val === '5' ? 8 : 7
    },
    toggleKeyboardMode() {
      this.useSystemKeyboard = !this.useSystemKeyboard
      this.plate = ''
      // 确保在切换后重新渲染
      this.$nextTick(() => {
        // 如果需要，可以手动控制 focus
      })
    },
    handleCompositionEnd(e) {
      this.isComposing = false;
      // composition 结束后，获取最终值
      let value = e.target.value;
      if (value.length > this.isNewEnergy) {
        value = value.substring(0, this.isNewEnergy);
      }
      this.plate = value.toUpperCase();
    },
    onTextareaFocus() {
      // 聚焦时确保光标位置正确
      this.$nextTick(() => {
        // 如果需要，可以在这里做额外处理
      })
    },

    onTextareaBlur() {
      // 失去焦点时同步数据
      // 如果需要，可以在这里做额外处理
    },

    onSystemInput(e) {
      // 限制长度
      // 如果正在中文输入，不处理
      if (this.isComposing) return;

      let value = e.target.value;
      if (value.length > this.isNewEnergy) {
        value = value.substring(0, this.isNewEnergy);
      }
      // 转大写（车牌字母通常大写）
      this.plate = value.toUpperCase();
    },
    getHistoryPlate() {
      let history = JSON.parse(localStorage.getItem('historyPlate') || '[]');
      this.historyPlate = history
      console.log(this.historyPlate)
    },

    clearHistoryBtn() {
      this.historyPlate = []
      localStorage.removeItem("historyPlate");
    },
    saveHistoryPlate(plate, plateColor) {
      // let history = localStorage.historyPlate || []
      try {
        let history = JSON.parse(localStorage.getItem('historyPlate') || '[]');
        history = history.filter(item => !(item.plate === plate && item.plateColor === plateColor))
        history.unshift({ plate, plateColor })
        if (history.length > 8) history.length = 8
        console.log(history)
        console.log(history)
        localStorage.setItem('historyPlate', JSON.stringify(history));
      } catch (e) {

      }

    },

    clickHistoryPlate(item){
      if(item.plate){
        this.$router.push(
          `/bill?plate=${item.plate}&plateColor=${item.plateColor}`
        );
      }
    },

    search() {
      if (this.plate.length > 6) {
        this.saveHistoryPlate(this.plate, this.plateColor)
        this.$router.push(
          `/bill?plate=${this.plate}&plateColor=${this.plateColor}`
        );
      } else {
        this.$toast.fail("请输入正确的车牌号");
      }
    },
    onSelect(item) {
      this.actionsValue = item.name;
      this.plateColor = item.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.plate {
  height: 100%;
  background-color: #fff;

  .parking {
    text-align: center;
    padding: 0.9rem 0 0.5rem 0;

    img {
      width: 6.2rem;
      height: auto;
    }
  }

  .forms {
    width: 6.5rem;
    margin: 0 auto;

    input {
      display: block;
      width: 100%;
      height: 0.9rem;
      margin: 0.3rem auto;
      background: #f3f3f3;
      border-radius: 8px;
      border: 0;
      text-align: center;
      font-size: 0.3rem;
    }
  }

  .search {
    display: block;
    width: 6.5rem;
    height: 0.9rem;
    margin: 2rem auto 0 auto;
    background: #1ca6ff;
    border-radius: 8px;
    border: 0;
    text-align: center;
    font-size: 0.3rem;
    color: #fff;
  }
}

.lisence_box {
  position: relative;
  /* 必须加，让 textarea 定位正确 */
  overflow: hidden;
  /* 防止 textarea 溢出 */
  width: 90%;
  margin: 0 auto;
  height: 1.4rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // margin-top: 1.0rem;

  div {
    width: 0.8rem;
    height: 0.8rem;
    background: #F5F5F5;
    border-radius: 0.1rem;
    color: #333;
    text-align: center;
    line-height: 0.8rem;
    font-weight: bold;
  }
}

/deep/ .van-radio {
  display: inline-flex;
  align-items: center;
  margin-right: 16px;
}

.search-title {
  font-size: 18px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  padding: 0px 20px 0px 20px;
}

/* textarea 样式需在全局生效 */
.system-input-cover {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;

  /* 隐藏所有视觉 */
  background: transparent !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;

  /* 关键：隐藏光标和文字 */
  color: transparent !important;
  caret-color: transparent !important;
  text-shadow: 0 0 0 black !important;
  /* 修复文字重影 */

  /* 隐藏滚动条 */
  -webkit-appearance: none;
  appearance: none;
  resize: none !important;
  overflow: hidden !important;

  /* 完全透明 */
  opacity: 0 !important;

  /* 防止选中文本 */
  user-select: none !important;
  -webkit-user-select: none !important;

  z-index: 10 !important;
  pointer-events: auto !important;
}

.history-view {
  display: flex;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
  margin-top: 0.5rem;

  img{
    width: 20px;
    height: 20px;
  }
}

.history-plate-title {
  width: 100%;
  text-align: left;
  height: 79upx;
  line-height: 79upx;
  font-size: 28upx;
  font-weight: 600;
  margin-left: 40upx;
}


.history-plate {

  text-align: left;
  // padding-left: 40upx;
  // padding-right: 40upx;
  padding-left: 0.2rem;
  padding-right: 0.2rem;

  .plate {
    padding: 8px;
    font-size: 14px;
    display: inline-block;
    background-color: #F5F5F5;
    margin: 2px;
    border-radius: 999px;
  }
}
</style>